import CRUDService from './CRUDService';

export default new CRUDService('/v1/survey-responses');
